<template>
<div>
  1.0
</div>
</template>

<script>
export default {
  name: "adc"
}
</script>

<style scoped>

</style>